import { render, staticRenderFns } from "./DashboardOperadora.vue?vue&type=template&id=4b70d078&scoped=true"
import script from "./DashboardOperadora.vue?vue&type=script&lang=ts"
export * from "./DashboardOperadora.vue?vue&type=script&lang=ts"
import style0 from "./DashboardOperadora.vue?vue&type=style&index=0&id=4b70d078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70d078",
  null
  
)

export default component.exports